<div class="online-course-selector__header" [attr.data-qa]="'onLineCourseSelector_header'">
  <div class="online-course-selector__header__items" i18n>All courses offer:</div>
  <div class="online-course-selector__header__items">
    <i class="pi pi-circle-fill online-course-selector__header__items__bullet-point"></i>
    <ng-container i18n>Tailored live sessions</ng-container>
  </div>
  <div class="online-course-selector__header__items">
    <i class="pi pi-circle-fill online-course-selector__header__items__bullet-point"></i>
    <ng-container i18n>Small groups coached by highly qualified teachers</ng-container>
  </div>
  <div class="online-course-selector__header__items">
    <i class="pi pi-circle-fill online-course-selector__header__items__bullet-point"></i>
    <ng-container i18n>Access to the K+ Learning Space (500 free lessons and interactive IELTS mock tests)</ng-container>
  </div>
</div>
@if (courseOptions()) { @for (course of courseOptions(); track course.code) {
<lx-option-card
  [class.online-course-selector__radio-button]="!course?.mostPopular"
  [type]="'radio'"
  [label]="course?.mostPopular ? label : ''"
  [title]="course && course[titlePathName()] ? course[titlePathName()] : ''"
  [option]="course?.code"
  [withImage]="false"
  [selectedOption]="selectedCourse?.code"
  (keydown.enter)="setSelectedCourse(course)"
  (selectedOptionChanged)="setSelectedCourse(course)"
  [attr.data-qa]="'onLineCourseSelector_card-' + course?.code"
>
  <div class="online-course-selector__duration" i18n>
    {{ course?.lesson?.durationMinutes / 60 | lxLocalizeAndPluralizePeriod : DurationUnitEnum.HOURS }} per day, {{ course?.lesson?.numberOfLessons }} days a
    week
  </div>
  <div class="online-course-selector__price">
    <div class="online-course-selector__price__label" i18n>from (per week)</div>
    <lx-price-label [endPrice]="course?.samplePrice"></lx-price-label>
  </div>
</lx-option-card>
} }
